import React, { useState } from 'react';
import { X, Trash2, AlertTriangle } from 'lucide-react';
import './ProductModal.css';

const DeleteProductModal = ({ product, onClose, onDelete }) => {
  const [loading, setLoading] = useState(false);
  const [confirmText, setConfirmText] = useState('');

  const handleDelete = async () => {
    setLoading(true);
    try {
      await onDelete(product.id);
      onClose();
    } catch (error) {
      console.error('Error deleting product:', error);
      alert('Error al eliminar el producto');
    } finally {
      setLoading(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const isConfirmed = confirmText.toLowerCase() === 'eliminar';

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content delete-modal">
        {/* Header */}
        <div className="modal-header delete-header">
          <div>
            <h2 className="modal-title">
              <AlertTriangle size={24} className="inline-icon" />
              Eliminar Producto
            </h2>
            <p className="modal-subtitle">Esta acción no se puede deshacer</p>
          </div>
          <button 
            className="btn-icon" 
            onClick={onClose}
            type="button"
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          <div className="delete-warning">
            <div className="warning-icon">
              <AlertTriangle size={48} />
            </div>
            <p className="warning-text">
              ¿Está seguro que desea eliminar el producto?
            </p>
            <div className="product-details">
              <div className="detail-row">
                <span className="detail-label">Nombre:</span>
                <span className="detail-value">{product.nombre}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Código:</span>
                <span className="detail-value">{product.code}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Categoría:</span>
                <span className="detail-value">{product.category}</span>
              </div>
            </div>
            <div className="confirmation-section">
              <p className="confirmation-instruction">
                Para confirmar, escriba <strong>ELIMINAR</strong> en el campo de abajo:
              </p>
              <input
                type="text"
                className="form-input confirmation-input"
                value={confirmText}
                onChange={(e) => setConfirmText(e.target.value)}
                placeholder="Escriba ELIMINAR"
                autoFocus
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-outline"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDelete}
            disabled={loading || !isConfirmed}
          >
            <Trash2 size={18} />
            {loading ? 'Eliminando...' : 'Eliminar Producto'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteProductModal;
